import type { DeviceIntervalsState } from './types'

const state = (): DeviceIntervalsState => ({
  activeIntervalId: null,
  activeIntervalType: null,
  appUpdateCallback: null,
  appInterval: null
})

export default state
